import { render, staticRenderFns } from "./items_meta.vue?vue&type=template&id=f3b6a7be&"
import script from "./items_meta.vue?vue&type=script&lang=js&"
export * from "./items_meta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports